import React, { useState } from 'react';

const FONT = '"Nunito","Baloo 2",sans-serif';

export default function ClozeGame({ payload, onAnswer, disabled }) {
  const [picked, setPicked] = useState(null);
  const correctIdx = payload.correct_index;
  const opts = payload.options || [];

  const click = (idx) => {
    if (picked !== null) return;
    setPicked(idx);
    if (onAnswer) onAnswer({
      is_correct: idx === correctIdx,
      user_answer: idx,
    });
  };

  // Render sentence with blank highlighted
  const sentence = payload.sentence_with_blank || '';
  const parts = sentence.split('____');
  const blank = picked !== null ? opts[correctIdx]?.text : '____';

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', fontFamily: FONT }}>
      <div
        style={{
          padding: 22,
          background: '#fefce8',
          border: '2px solid #fde68a',
          borderRadius: 14,
          textAlign: 'center',
          fontSize: 22,
          fontWeight: 600,
          minHeight: 100,
          lineHeight: 1.5,
        }}
      >
        {parts[0]}
        <span
          style={{
            display: 'inline-block',
            minWidth: 80,
            padding: '2px 10px',
            margin: '0 4px',
            borderBottom: '3px solid #1e40af',
            color: picked !== null ? (picked === correctIdx ? '#065f46' : '#991b1b') : '#1e40af',
            fontWeight: 800,
          }}
        >
          {picked !== null ? opts[picked]?.text : '____'}
        </span>
        {parts[1] || ''}
      </div>
      {payload.translation_vi ? (
        <div style={{ marginTop: 8, color: '#6b7280', fontStyle: 'italic', textAlign: 'center' }}>
          ({payload.translation_vi})
        </div>
      ) : null}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 16 }}>
        {opts.map((opt, i) => {
          const isCorrect = i === correctIdx;
          const isPicked = i === picked;
          let bg = '#fff', border = '#d1d5db';
          if (picked !== null) {
            if (isCorrect) { bg = '#d1fae5'; border = '#10b981'; }
            else if (isPicked) { bg = '#fee2e2'; border = '#ef4444'; }
          }
          return (
            <button
              key={i}
              onClick={() => click(i)}
              disabled={picked !== null || disabled}
              style={{
                padding: 14,
                background: bg,
                border: `2px solid ${border}`,
                borderRadius: 12,
                fontSize: 17,
                fontWeight: 600,
                cursor: picked === null && !disabled ? 'pointer' : 'default',
                fontFamily: FONT,
              }}
            >
              {opt.text}
            </button>
          );
        })}
      </div>

      {picked !== null && payload.explanation_vi ? (
        <div style={{ marginTop: 14, padding: 12, background: '#f3f4f6', borderRadius: 10 }}>
          {payload.explanation_vi}
        </div>
      ) : null}
    </div>
  );
}
